import moment from 'moment';
import React, { useState, useEffect, forwardRef, useImperativeHandle } from 'react'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import TimePicker from 'react-time-picker';
import 'react-time-picker/dist/TimePicker.css';
import 'react-clock/dist/Clock.css';
import { determineCommaSeprater, validateCultureNumber, formatNumberCustomoriginal, dateFormatByAccountCulture } from '../../common/timeLiveFunction';
import { removeTimeEntryRow, updateIsReload, updateIsStateHour, updateIsStateMinute, updateTabIndex, updateTimeEntriesAsync } from './timesheetSlice'
import { ShowSwalWithConfirmation } from '../../common/SweetAlert';
import { ShowToast } from '../../common/Toastr';

// let isTimesheetLocked: boolean = false;
const CustomFieldPopover = forwardRef((props: any, ref: any) => {
    const { showRelative,rowId,detailRowId } = props;

    const dispatch = useAppDispatch();
    const { decimalPlaces, CurrentCultureDateFormat, cultureInfoName, dateInsertionFormat, customFieldInsertionFormat, calendarStartDay } = useAppSelector(state => state.globalState);
    const { customFieldsTemplate, showClockStartEnd, timeEntryFormat, decimalFormat, currentDate, status, timeEntriesList, isLocked, showTimeEntriesDescription, timeEntryViewType , accountEmployeeId, accountEmployeeTimeEntryPeriodId} = useAppSelector(state => state.timesheet);
    const currentRow = timeEntriesList.find(x => x.rowId === rowId);    
    const currentDetailRow = currentRow.timeEntries[detailRowId];
    const [isChanged, setIsChanged] = useState<any>(false);
    const [isTimeOff, setIsTimeOff] = useState<any>(false);
    const [totalTime, setTotalTime] = React.useState(props.timeEntryHours);
    const [cfValues, setCfValues] = useState<any>({
        StartTime: moment().format('HH:mm'),
        EndTime: moment().format('HH:mm'),
        Description: "",
        CustomField1: "",
        CustomField2: "",
        CustomField3: "",
        CustomField4: "",
        CustomField5: "",
        CustomField6: "",
        CustomField7: "",
        CustomField8: "",
        CustomField9: ""
    });
    const [previousState, setPreviousState] = useState<any>({
        StartTime: moment().format('HH:mm'),
        EndTime: moment().format('HH:mm'),
        Description: "",
        CustomField1: "",
        CustomField2: "",
        CustomField3: "",
        CustomField4: "",
        CustomField5: "",
        CustomField6: "",
        CustomField7: "",
        CustomField8: "",
        CustomField9: ""
    });

const isRecordNotSubmitted = (props.status === "record-not-submitted" || currentDetailRow?.status === "record-not-submitted");
const isFieldLocked = isLocked && !isRecordNotSubmitted;

    useEffect(() => {
        if (props.status != "record-validation-failed") {
            if (props.id) {
                // const currentDetailRowWIthId = timeEntriesList.find(x => x.rowId === props.rowId).timeEntries[props.detailRowId];
                // setCfValues(currentDetailRowWIthId);
                // setPreviousState(currentDetailRowWIthId);
                const currentDetailRowWIthId = timeEntriesList.find(x => x.rowId === props.rowId).timeEntries[props.detailRowId];
                const entry = timeEntriesList.find(x => x.rowId === props.rowId);
                if (entry.AccountEmployeeTimeOffRequestId != null) {
                    setIsTimeOff(true);
                } else {
                    setIsTimeOff(false);
                }
                // if (entry && typeof entry.isTimeOff === 'string') {
                //     setIsTimeOff(true);
                // } else {
                //     setIsTimeOff(false);
                // }
                let updatedDetailRow = { ...currentDetailRowWIthId }
                let dateObject;
                let isValidDate;
                if (Object.keys(currentDetailRowWIthId).length > 0) {
                    Object.keys(updatedDetailRow).forEach((item) => {
                        dateObject = new Date(updatedDetailRow[item]);
                        isValidDate = !isNaN(dateObject.getTime());
                        if (item === 'StartTime' && isValidDate) {
                            updatedDetailRow[item] = moment.parseZone(updatedDetailRow[item]).format('HH:mm');
                        }
                        if (item === 'EndTime' && isValidDate) {
                            updatedDetailRow[item] = moment.parseZone(updatedDetailRow[item]).format('HH:mm');
                        }
                    })
                }
                setCfValues(updatedDetailRow);
                setPreviousState(updatedDetailRow);
            }
            else {
                let NewCfValue = { ...cfValues };
                customFieldsTemplate.filter(x => !x.IsDisabled)
                    .map(x => {
                        if (cfValues[x.DatabaseFieldName] == "" && x.DefaultValue != "" && x.MasterCustomDataTypeName != "Date") {
                            NewCfValue[x.DatabaseFieldName] = x.DefaultValue;
                        }
                        if (cfValues[x.DatabaseFieldName] == "" && x.MasterCustomDataTypeName == "Date") {
                            // NewCfValue[x.DatabaseFieldName] = moment().format(CurrentCultureDateFormat.toUpperCase());
                            NewCfValue[x.DatabaseFieldName] = moment(new Date()).format(customFieldInsertionFormat);
                        }
                    });
                setCfValues(NewCfValue);
                setPreviousState(NewCfValue);
            }
        } else {
            const currentRow = timeEntriesList.find(x => x.rowId === props.rowId);
            const currentDetailRow = currentRow.timeEntries[props.detailRowId];
            if (currentDetailRow.AccountEmployeeTimeEntryId == props.id) {
                const { ErrorMessage: _, HoursDisplayText: __,
                    code: ___, rowId: ____, status: _____,
                    AccountEmployeeTimeEntryId: ______, Hours: _______, TimeEntryDate: ________,
                    ...currentDetailRow } = currentRow.timeEntries[props.detailRowId];
                currentDetailRow.StartTime = cfValues.StartTime;
                currentDetailRow.EndTime = cfValues.EndTime;
                setCfValues(currentDetailRow);
                setPreviousState(currentDetailRow);
            }
        }
        // isTimesheetLocked = setTimesheetLocked(isLockedSubmittedRecord, isLockedApprovedRecord, timesheetStatus.text);
    }, [props.id]);

    const onChangeHandler = (e: any) => {
        setCfValues({ ...cfValues, [e.target.name]: e.target.value });
        setIsChanged(previousState[e.target.name] != e.target.value);
    }

    const onChangeHandlerForDatePicker = (e: any, name: any) => {
        // const date = moment(e).format(CurrentCultureDateFormat.toUpperCase());
        // const date = e ? moment(e).format(CurrentCultureDateFormat.toUpperCase()) : moment().format(CurrentCultureDateFormat.toUpperCase());
        const date = e ? moment(e).format(customFieldInsertionFormat) : moment().format(customFieldInsertionFormat);
        setCfValues({ ...cfValues, [name]: date });
        setIsChanged(previousState[name] != date);
    }

    useImperativeHandle(ref, () => ({
        getIsChanged: () => {
            return isChanged
        },
        getCustomFieldValues: () => {
            return cfValues
        },
        getTotalTimeValue: () => {
            return totalTime
        },
    }), [isChanged, cfValues]);

    const onDateChange = (timeValue: any, name: string) => {
        const newPeriod = timeValue.includes("AM") ? "AM" : "PM";
        let endTime
        let startTime
        if (name === 'EndTime') {
            endTime = moment(timeValue, 'HH:mm');
        } else {
            endTime = moment(cfValues.EndTime, 'HH:mm');
        }
        if (name === 'StartTime') {
            startTime = moment(timeValue, 'HH:mm');
        } else {
            startTime = moment(cfValues.StartTime, 'HH:mm');
        }
        if (startTime.isValid() && endTime.isValid()) {
            var hrs = moment.utc(endTime.diff(startTime)).format("HH");
            var min = moment.utc(endTime.diff(startTime)).format("mm");
            var totalTimeValue = [hrs, min].join(':');
            setTotalTime(totalTimeValue);
            setCfValues({ ...cfValues, [name]: timeValue });
        }
        else {
            setTotalTime("00:00");
            setCfValues({ ...cfValues, [name]: "00:00" });
        }
    }

    // const formatTime = timeEntryFormat === "HH:mm" ? "H:m" : "h:m a"
    const formatTime = timeEntryFormat === "HH:mm" ? "HH:mm" : "h:mm a";

    // let cFLength = customFieldsTemplate.length - 1;

    // const updateOnTab = (MasterCustomDataTypeId: string) => {
    //     // customFieldsTemplate[cFLength].MasterCustomDataTypeId === MasterCustomDataTypeId;
    //     cFLength = cFLength - 1;
    //     cFLength === 0 && dispatch(updateTabIndex(true))
    // }


     const handleOnDeleteIcon = (Id: any) => {
        console.log('currentDetailRow.AccountEmployeeTimeEntryId : ',currentDetailRow.AccountEmployeeTimeEntryId)
           ShowSwalWithConfirmation('Are you sure you want to delete this record?', "Removed entry will not be recovered", "Yes, Proceed", "custom-swal-container")
                      .then((result) => {
                          dispatch(updateIsStateHour(false));
                          dispatch(updateIsStateMinute(false));
                          if (result) {
                              const { AccountClientId, AccountProjectId, AccountProjectTaskId, AccountEmployeeTimeEntryApprovalProjectId } = currentRow;
                              const postObject = {
                                  AccountEmployeeId: accountEmployeeId,
                                  AccountClientId,
                                  AccountProjectId,
                                  AccountProjectTaskId,
                                  ApprovalProjectId: AccountEmployeeTimeEntryApprovalProjectId,
                                  AccountEmployeeTimeEntryPeriodId: accountEmployeeTimeEntryPeriodId,
                                  TimeEntries: [currentDetailRow.AccountEmployeeTimeEntryId],
                                  IsTimeOff: currentRow.isTimeOff === "1" ? true : false,
                                  IsDelete: true
                              }
                              dispatch(updateTimeEntriesAsync({ RowId: rowId, ...postObject }))
                                  .unwrap()
                                  .then((originalPromiseResult) => {
                                      dispatch(updateIsReload(true));
                                  })
                                  .catch((rejectedValueOrSerializedError) => {
                                  });
                          } else {
                             
                              //setTimeEntryHours(displayValueForTimeEntry(currentDetailRow.Hours, isTimesheetPolicy, decimalFormat));
                              return;
                          }
                      })
                      .catch((error) => {
                      });
        }

    return (
        <div ref={ref}
            className={`popover timesheet-popover fade ${showRelative ? 'left' : 'bottom'} in`}
            style={(!(timeEntryViewType === "Daily") && showRelative) ? {
                position: 'absolute', left: '-200px',
                top: '100%',
                transform: 'translateY(-5%)',
            } : { position: 'absolute' }}>
            <div className={"arrow"} style={{ left: "50%" }}></div>
            <div className={"popover-content timesheet-input-popover"}>
                {showClockStartEnd && !decimalFormat &&
                    <div>
                        <div style={{ display: 'flex', flexDirection: 'row' }}>
                            <div className={"custom-field-item"}>
                                <label className={"d-block custom-field-label"}>Start Time</label>
                                <TimePicker
                                    name='StartTime'
                                    value={cfValues.StartTime}
                                    onChange={time => { onDateChange(time, 'StartTime') }}
                                    data-testid={"StartTimeDiv"}
                                    clockIcon={null}
                                    disableClock={true}
                                    format={formatTime}
                                    disabled={isFieldLocked ? true : false}
                                    className={" custom-field timePickeWd"}
                                />
                            </div>
                            <div className={"custom-field-item"} style={{ marginLeft: 4 }}>
                                <label className={"d-block custom-field-label"}>End Time</label>
                                <TimePicker
                                    name='EndTime'
                                    value={cfValues.EndTime}
                                    onChange={e => { onDateChange(e, 'EndTime') }}
                                    clockIcon={null}
                                    disableClock={true}
                                    format={formatTime}
                                    disabled={isFieldLocked ? true : false}
                                    className={"custom-field timePickeWd"}
                                />
                            </div>
                            

                            
                        </div>
                       
                        {currentDetailRow.AccountEmployeeTimeEntryId &&
                            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'end' }}>
                                <span style={{ fontWeight: 800, alignItems: 'right' }}>{totalTime}</span>
                                <span style={{ fontWeight: 200, marginLeft: 4, alignItems: 'right' }}>{"hrs"}</span>
                                <i
                                    className="bi bi-trash fs-6 delete-menu-icon-color allign mt-1"
                                    style={{ cursor: "pointer", marginBottom: 6, marginLeft: 2 }}
                                    onClick={() => handleOnDeleteIcon(rowId)}
                                >
                                    <span className="path1"></span>
                                    <span className="path2"></span>
                                </i>
                            </div>}
                        
                    </div>
                }
                {showTimeEntriesDescription && <div className={"custom-field-item"}>
                    <label className={"d-block custom-field-label"}>Description</label>
                    <textarea
                        name="Description"
                        onChange={onChangeHandler}
                        value={cfValues.Description}
                        rows={2}
                        // readOnly={isLocked ? true : false}
                        readOnly={isFieldLocked ? true : isTimeOff ? true : false}
                        // readOnly={isLocked ? true : isTimeOff ? props.id != null ? true : false : false}
                        className={"form-control form-control-sm input-sm +-field"}
                        style={{ height: "56px" }}
                    // onKeyDown={() => { cFLength === 0 && dispatch(updateTabIndex(true)) }}
                    >
                    </textarea>
                </div>}
                {customFieldsTemplate.filter((x: any) => !x.IsDisabled).map((x: any, index: any) =>
                    <div key={index} className={"custom-field-item"}>
                        <label className={"d-block custom-field-label"}>{x.CustomFieldCaption}</label>
                        {x.MasterCustomDataTypeName == "Drop-Down" &&
                            <select
                                name={x.DatabaseFieldName}
                                className={"form-control form-control-sm input-sm custom-field cf-select"}
                                onChange={onChangeHandler}
                                required={x.IsRequired ? x.IsRequired : ""}
                                // disabled={isLocked ? true : false}
                                disabled={isFieldLocked ? true : isTimeOff ? true : false}
                                // disabled={isLocked ? true : isTimeOff ? props.id != null ? true : false : false}
                                value={(cfValues[x.DatabaseFieldName] ? cfValues[x.DatabaseFieldName] : x.DefaultValue)}
                            // onKeyDown={() => { updateOnTab(x.MasterCustomDataTypeId) }}
                            >
                                <option value="None">None</option>
                                {x.DropDownOptions != null &&
                                    x.DropDownOptions.split("+").map((value: any, index: any) =>
                                        <option key={index} value={value} >{value}</option>)
                                }
                            </select>}
                        {x.MasterCustomDataTypeName == "Date" &&
                            <DatePicker
                                name={x.DatabaseFieldName}
                                onChange={(date) => onChangeHandlerForDatePicker(date, x.DatabaseFieldName)}
                                // disabled={isLocked ? true : false}
                                disabled={isFieldLocked ? true : isTimeOff ? true : false}
                                calendarStartDay={calendarStartDay}
                                // disabled={isLocked ? true : isTimeOff ? props.id != null ? true : false : false}
                                //selected={(cfValues[x.DatabaseFieldName] ? moment(cfValues[x.DatabaseFieldName], CurrentCultureDateFormat.toUpperCase()).toDate() : moment().toDate())}
                                selected={(cfValues[x.DatabaseFieldName] ? dateFormatByAccountCulture(cfValues[x.DatabaseFieldName], cultureInfoName.toString()) : new Date())}
                                className={"form-control form-control-sm input-sm custom-field custom-field " + (isFieldLocked ? 'disabled' : '')}
                                dateFormat={CurrentCultureDateFormat.toString()}
                            // onKeyDown={() => { updateOnTab(x.MasterCustomDataTypeId) }}
                            />}
                        {(x.MasterCustomDataTypeName == "Text") &&
                            <input
                                name={x.DatabaseFieldName}
                                defaultValue={cfValues[x.DatabaseFieldName]}
                                onChange={onChangeHandler}
                                className={"form-control form-control-sm input-sm custom-field custom-field"}
                                maxLength={x.MaximumLength ? x.MaximumLength : ""}
                                max={x.MaximumValue ? x.MaximumValue : ""}
                                min={x.MinimumValue ? x.MinimumValue : ""}
                                required={x.IsRequired ? x.IsRequired : ""}
                                type="text"
                                // readOnly={isLocked ? true : false}
                                disabled={isFieldLocked ? true : isTimeOff ? true : false}
                            // readOnly={isLocked ? true : isTimeOff ? props.id != null ? true : false : false}
                            // onKeyDown={() => { updateOnTab(x.MasterCustomDataTypeId) }}
                            />}
                        {(x.MasterCustomDataTypeName == "Number") &&
    <input
        name={x.DatabaseFieldName}
        value={cfValues[x.DatabaseFieldName] || ''}
        onChange={(e) => {
            const value = e.target.value;
            if (validateCultureNumber(value, cultureInfoName.toString(), decimalPlaces)) {
                setCfValues({ ...cfValues, [x.DatabaseFieldName]: value });
                setIsChanged(previousState[x.DatabaseFieldName] != value);
            }
        }}
        onBlur={(e) => {
            const formatted = formatNumberCustomoriginal(
                cultureInfoName.toString(),
                e.target.value,
                decimalPlaces
            );

        // Validate min/max
        const normalizedValue = formatted.replace(',', '.');
        const numericValue = parseFloat(normalizedValue);

        if (!isNaN(numericValue)) {
            // Check minimum value
            if (x.MinimumValue && numericValue < parseFloat(x.MinimumValue)) {
                const minFormatted = formatNumberCustomoriginal(
                    cultureInfoName.toString(),
                    x.MinimumValue.toString(),
                    decimalPlaces
                );
                setCfValues({ ...cfValues, [x.DatabaseFieldName]: formatted });
                return;
            }
            
            // Check maximum value
            if (x.MaximumValue && numericValue > parseFloat(x.MaximumValue)) {
                const maxFormatted = formatNumberCustomoriginal(
                    cultureInfoName.toString(),
                    x.MaximumValue.toString(),
                    decimalPlaces
                );
                setCfValues({ ...cfValues, [x.DatabaseFieldName]: formatted });
                return;
            }
        }

            setCfValues({ ...cfValues, [x.DatabaseFieldName]: formatted });
            setIsChanged(previousState[x.DatabaseFieldName] != formatted);
        }}
        className={"form-control form-control-sm input-sm custom-field custom-field"}
        maxLength={x.MaximumLength ? x.MaximumLength : ""}
        //max={x.MaximumValue ? x.MaximumValue : ""}
        //min={x.MinimumValue ? x.MinimumValue : ""}
        required={x.IsRequired ? x.IsRequired : ""}
        type="text"
        disabled={isFieldLocked ? true : isTimeOff ? true : false}
    />
    }
                    </div>
                )}
            </div>
        </div>
    )
})

export default CustomFieldPopover